/**
 * ThemeToggle
 *
 * Sun/moon icon button that flips light/dark mode.
 */
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../hooks/useTheme.js';

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className="flex h-8 w-8 items-center justify-center rounded-md border border-edge text-secondary transition-colors hover:bg-surface-hover hover:text-primary"
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
};
